import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { BauenLogoFull } from "@/components/BauenLogo";
import { Loader2 } from "lucide-react";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { toast.error("A senha deve ter ao menos 8 caracteres"); return; }
    if (password !== confirm) { toast.error("As senhas não conferem"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Senha redefinida! Faça login.");
      navigate("/login");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Não foi possível redefinir");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background" data-testid="reset-password-page">
      <div className="w-full max-w-md animate-fade-in-up">
        <BauenLogoFull className="mb-8" />
        <h2 className="font-heading text-2xl font-semibold">Definir nova senha</h2>
        <p className="mt-1 text-sm text-muted-foreground">Este link expira em 60 minutos.</p>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <div className="space-y-2">
            <Label htmlFor="rp-pw">Nova senha</Label>
            <Input id="rp-pw" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="reset-password-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="rp-confirm">Confirmar senha</Label>
            <Input id="rp-confirm" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
              data-testid="reset-password-confirm-input" />
          </div>
          <Button type="submit" disabled={loading || !token} className="w-full h-11" data-testid="reset-submit-btn">
            {loading ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />Redefinindo…</> : "Redefinir senha"}
          </Button>
        </form>
        <Link to="/login" className="mt-6 inline-block text-sm text-primary hover:underline">Voltar ao login</Link>
      </div>
    </div>
  );
}
